/** Tipos da Carteira de Clientes */
export interface ClienteCarteiraTipo {
    id: number;
    nome: string;
    abreviacao: string;
    cor: string;
}

export const clienteCarteiraTipoPotencial: ClienteCarteiraTipo = {
    id: 1,
    nome: 'Carteira Potencial',
    abreviacao: 'POT',
    cor: '#dddddd'
};
export const clienteCarteiraTipoPretendida: ClienteCarteiraTipo = {
    id: 2,
    nome: 'Carteira Pretendida',
    abreviacao: 'PRE',
    cor: '#237dd8'
};
export const clienteCarteiraTipoProjetada: ClienteCarteiraTipo = {
    id: 3,
    nome: 'Carteira Projetada',
    abreviacao: 'PRO',
    cor: '#5e40a4'
};
export const clienteCarteiraTipoRealizada: ClienteCarteiraTipo = {
    id: 4,
    nome: 'Carteira Realizada',
    abreviacao: 'REA',
    cor: '#20b75d'
};
export const clienteCarteiraTipoPositivaEmpresa: ClienteCarteiraTipo = {
    id: 5,
    nome: 'Carteira Positiva Empresa',
    abreviacao: 'CPE',
    cor: '#499466'
};
export const clienteCarteiraTipoPositivaRepresentante: ClienteCarteiraTipo = {
    id: 6,
    nome: 'Carteira Positiva Representante',
    abreviacao: 'CPR',
    cor: '#499466'
};

export const clienteCarteiraTipos: ClienteCarteiraTipo[] = [
    clienteCarteiraTipoPotencial,
    clienteCarteiraTipoPretendida,
    clienteCarteiraTipoProjetada,
    clienteCarteiraTipoRealizada,
    clienteCarteiraTipoPositivaEmpresa,
    clienteCarteiraTipoPositivaRepresentante
];
